import { isPlatformServer } from '@angular/common';
import { ABTest } from '@freelancer/abtest';
import { RedirectToPhp } from '@freelancer/redirect-to-php';
import { Tracking } from '@freelancer/tracking';
import * as Rx from 'rxjs';
import { switchMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../redirect-to-php/redirect-to-php.service";
import * as i2 from "../abtest/abtest.service";
import * as i3 from "../tracking/tracking.service";
/**
 * This service can be injected as a login service.
 * It redirects to the gaf/login.php page unless `w=t` is set.
 * In future this may just become a `NoRedirectLogin` service.
 */
var Login = /** @class */ (function () {
    function Login(redirectToPhp, abtest, platformId, tracking) {
        this.redirectToPhp = redirectToPhp;
        this.abtest = abtest;
        this.platformId = platformId;
        this.tracking = tracking;
    }
    Login.prototype.redirect = function (next, routeSnapshot) {
        var _this = this;
        if (routeSnapshot && routeSnapshot.queryParams.w === 't') {
            return Rx.of(true);
        }
        if (isPlatformServer(this.platformId)) {
            return Rx.from(this.abtest
                .handleServer()
                .then(function () {
                return _this.redirectToPhp
                    .doRedirect(next ? "/login?next=" + next : '/login')
                    .toPromise();
            }));
        }
        if (this.abtest.isWhitelistUser()) {
            return Rx.of(true);
        }
        return this.tracking.getSessionId().pipe(switchMap(function (sessionId) {
            if (_this.abtest.shouldEnrol('T140960-webapp-login-signup-v2', sessionId, 0.05)) {
                // https://www.freelancer.com/admin/abtest/index.php?action=show_experiment&experiment_id=1067
                return _this.abtest
                    .getSessionExperimentVariation('T140960-webapp-login-signup-v2')
                    .pipe(switchMap(function (variation) {
                    if (variation === 'test') {
                        return Rx.of(true);
                    }
                    return _this.loginRedirectToPhp(next);
                }));
            }
            return _this.loginRedirectToPhp(next);
        }));
    };
    Login.prototype.loginRedirectToPhp = function (next) {
        if (next) {
            return this.redirectToPhp.doRedirect("/login?next=" + next);
        }
        return this.redirectToPhp.doRedirect('/login');
    };
    Login.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Login_Factory() { return new Login(i0.ɵɵinject(i1.RedirectToPhp), i0.ɵɵinject(i2.ABTest), i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i3.Tracking)); }, token: Login, providedIn: "root" });
    return Login;
}());
export { Login };
